export default (values, schema) => {
  const result = {};
  Object.keys(schema.fields).forEach(key => (result[key] = values[key]));
  return result;
};
